const PREFIX = 'MAPVIEW';

export const MAPVIEW_SESSION_STORAGE_KEYS = {
  FILTERED_SCHEDULE: `${PREFIX}_FILTERED_SCHEDULE`
};
